import { Component, inject, signal, ViewChild } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { SearchBarComponent } from '../../../shared/components/search-bar-component/search-bar-component';
import { MatCardModule } from '@angular/material/card';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { DatePipe, UpperCasePipe } from '@angular/common';
import { StockService } from '../../service/stock-service';
import { ToastrService } from '../../../shared/services/toastr-service';
import { RangePipe } from '../../../shared/pipes/range-pipe';
import { SweetAlertService } from '../../../shared/services/sweet-alert-service';
import { DistributionDetailsComponents } from '../distribution-details-components/distribution-details-components';

@Component({
  selector: 'app-stock-details-components',
  imports: [
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatSelectModule,
    SearchBarComponent,
    MatCardModule,
    MatPaginatorModule,
    MatSort,
    MatSortModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinner,
    RangePipe,
    DatePipe
  ],
  templateUrl: './stock-details-components.html',
  styleUrl: './stock-details-components.css',
})
export class StockDetailsComponents {
  displayedColumns: string[] = ['date', 'type', 'qte', 'reste', 'attestation', 'carte_rose', 'collaborateur', 'compagnie', 'editor', /*'action'*/];
  dataSource : MatTableDataSource<any> = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  searchValue = signal<string>('')
  readonly dialog = inject(MatDialog);

  readonly site = inject<{site_id : string ,site : string, groupe : string}>(MAT_DIALOG_DATA);

  loading : boolean = false

  constructor(
    private stockService : StockService,
    private toastr : ToastrService,
    private sweetAlert : SweetAlertService
  ){}

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.loadStocks()
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  loadStocks(){
    this.stockService.siteStockDetails(this.site.site_id).subscribe({
      next : (res) =>{
          this.dataSource.data = res
      },
      error : (err) =>{
        this.toastr.error("Une erreur est survenue")
      }
    })
  }

  applyFilter(event : string){

    this.searchValue.update(val => event)
    this.dataSource.filter = event.trim().toLocaleLowerCase()

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

    openShareModal(){
      const data  = {
        title : this.site.site,
        site_id : this.site.site_id
      }
  
      const dialogRef = this.dialog.open(DistributionDetailsComponents, {
        width : '800px',
        enterAnimationDuration : '500ms',
        exitAnimationDuration : '500ms',
        disableClose : true,
        data : data
      });
  
      dialogRef.afterClosed().subscribe((result : any) => {
        if (result?.id) {
           this.toastr.success()
           this.loadStocks()
        }
      });
    }

    onDelete(){
      this.sweetAlert.confirm("Voulez-vous vraiment supprimer ce stock ?")
      .then((res) =>{
        if(res.isConfirmed){
          this.stockService.delete(this.site.site_id).subscribe({
            next : (res) =>{
              this.loadStocks()
              this.toastr.success()
            },
            error : (err) =>{
              this.toastr.error("Une erreur est survenue")
            }
          })
        }
      })
    }

}
